const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the user track display component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('importedContentRegistrationDisplay', ['Application', function(Application) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        item: '@'
      },
      template: require('../../templates/directives/imported-content-registration-display.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.getError = Application.notifications.getError;
          self.getSuccess = Application.notifications.getSuccess;
          self.image = function() {
            if (!$scope.item || !self.importedContentRegistration) {
              return '';
            }
            if (self.importedContentRegistration.content.banner_image || self.importedContentRegistration.content.image) {
              var imageUrl = self.importedContentRegistration.content.banner_image ? self.importedContentRegistration.content.banner_image : self.importedContentRegistration.content.image;
              return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
            }
            return '';
          };
          self.goToImportedContent = function() {
            Application.navigation.goTo('/view/' + self.importedContentRegistration.type.replace('_', '-') + '/' + self.importedContentRegistration.content._id);
          };

          self.initialize = function() {
            self.importedContentRegistration = JSON.parse($scope.item);

            if (self.importedContentRegistration.completed_date) {
              self.importedContentRegistration.completed_date = moment(self.importedContentRegistration.completed_date).format('MMMM Do, YYYY');
            }

            if (self.importedContentRegistration.type === 'scorm') {
              self.importedContentRegistration.content.vendor = 'scorm';
              if (self.importedContentRegistration.timestamp) {
                self.importedContentRegistration.completed_date = moment(self.importedContentRegistration.timestamp).format('MMMM Do, YYYY');
              }
              if (self.importedContentRegistration.passed_failed_status === 'unknown') {
                self.importedContentRegistration.progress = 50;
              } else {
                self.importedContentRegistration.progress = 100;
              }
            } else {
              // As a default for imported content, if we have a completed status and no progress value, 
              //   set the progress value to 100.
              if (self.importedContentRegistration.completed) {
                self.importedContentRegistration.progress = 100;
              }
            }

            if (!self.importedContentRegistration.progress) {
              self.importedContentRegistration.progress = 0;
            }

            self.progress_style = {'width': self.importedContentRegistration.progress + '%'};
          };

          $scope.$watch('item', function() {
            if ($scope.item !== undefined) {
              self.initialize();
            }
          });
        }],
      controllerAs: 'display'
    };
  }]);


